export default __webpack_public_path__ + "static/media/eric-prouzet-zv6utzkYjEY-unsplash.1ad31692.jpg";